import { default as React, useState, useEffect, ReactNode } from 'react';

interface Props {
    children: ReactNode;
}

const DeferredRenderer = ({ children }: Props) => {
    const [rendered, setRendered] = useState(false);

    useEffect(() => {
        const timerRender = setTimeout(() => setRendered(true), 0);

        return () => {
            clearTimeout(timerRender);
        };
    }, []);

    if (!rendered) {
        return null;
    }

    return <>{children}</>;
};

export default DeferredRenderer;
